/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Approval_TitleInputs */

const en_event_approval_title = /** @type {(inputs: Event_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval`)
};

const fr_event_approval_title = /** @type {(inputs: Event_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approbation`)
};

const de_event_approval_title = /** @type {(inputs: Event_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigung`)
};

const it_event_approval_title = /** @type {(inputs: Event_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvazione`)
};

const ru_event_approval_title = /** @type {(inputs: Event_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одобрение`)
};

const es_event_approval_title = /** @type {(inputs: Event_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobación`)
};

const zh_cn2_event_approval_title = /** @type {(inputs: Event_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赞同`)
};

const ja_event_approval_title = /** @type {(inputs: Event_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認`)
};

const hi_event_approval_title = /** @type {(inputs: Event_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमोदन`)
};

const pt_pt2_event_approval_title = /** @type {(inputs: Event_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovação`)
};

/**
* | output |
* | --- |
* | "Approval" |
*
* @param {Event_Approval_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_approval_title = /** @type {((inputs?: Event_Approval_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Approval_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_approval_title(inputs)
	if (locale === "de") return de_event_approval_title(inputs)
	if (locale === "it") return it_event_approval_title(inputs)
	if (locale === "ru") return ru_event_approval_title(inputs)
	if (locale === "es") return es_event_approval_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_approval_title(inputs)
	if (locale === "ja") return ja_event_approval_title(inputs)
	if (locale === "hi") return hi_event_approval_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_approval_title(inputs)
	return en_event_approval_title(inputs)
});